var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2305,
    viewBox: "0 0 256 236",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.075 236.075l47.104-144.97H80.97l47.104 144.97z",
    fill: "#E24329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.075 236.074L80.97 91.104H14.956l113.119 144.97z",
    fill: "#FC6D26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.956 91.104L.642 135.16a9.752 9.752 0 0 0 3.542 10.903l123.891 90.012-113.12-144.97z",
    fill: "#FCA326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.956 91.105H80.97L52.601 3.79c-1.46-4.493-7.816-4.492-9.275 0l-28.37 87.315z",
    fill: "#E24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.075 236.074l47.104-144.97h66.015l-113.12 144.97z",
    fill: "#FC6D26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.194 91.104l14.314 44.056a9.752 9.752 0 0 1-3.543 10.903l-123.89 90.012 113.119-144.97z",
    fill: "#FCA326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.194 91.105h-66.015l28.37-87.315c1.46-4.493 7.816-4.492 9.275 0l28.37 87.315z",
    fill: "#E24329"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.4a31f1b0d7169fcc66bc864a62521c31.svg";
export { ForwardRef as ReactComponent };